<template>
    <div class="cf-container">
        <md-table v-if="hasOverrideDays" class="override-day-table">
            <md-table-row slot="header">
                <md-table-head>Name</md-table-head>
                <md-table-head>Override Date</md-table-head>
                <md-table-head>Actions</md-table-head>
            </md-table-row>

            <md-table-row v-for="(overrideDay, index) in filteredOverrideDays" :key="index">
                <md-table-cell class="override-day-name-column">
                    <form-group>
                        <md-input v-model="overrideDay.overrideDayName" type="text" placeholder="Eg. Valentine's Day" />
                    </form-group>
                </md-table-cell>
                <md-table-cell class="override-date-columns">
                    <md-datepicker
                        v-model="overrideDay.overrideDate"
                        md-immediately
                        :md-debounce="100"
                        :md-model-type="String"
                    ></md-datepicker>
                </md-table-cell>
                <md-table-cell class="action-buttons-column">
                    <md-button
                        title="Edit override day"
                        class="md-warning md-just-icon md-round"
                        @click="handleEditOverrideDay(overrideDay)"
                    >
                        <md-icon>edit</md-icon>
                    </md-button>
                    <md-button
                        title="Delete override day"
                        class="md-danger md-just-icon md-round"
                        @click="handleDeleteOverrideDay(overrideDay)"
                    >
                        <md-icon>delete</md-icon>
                    </md-button>
                </md-table-cell>
            </md-table-row>
        </md-table>
        <div class="text-center" v-if="!hasOverrideDays">
            <p class="no-result-message">List is empty.</p>
        </div>
        <div>
            <md-button class="md-button md-primary custom-add-override-day-button" @click="handleAddOverrideDay">
                <md-icon>add</md-icon>
                Add Override Days
            </md-button>
        </div>
    </div>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { rowStatus } from '@/helpers';

export default {
    name: 'ServiceAreasOverrideDay',
    mixins: [GeneralMixin],
    props: {
        serviceAreaId: {
            type: String,
            default: null
        },
        overrideDayData: {
            type: Object,
            default: () => ({ overrideDays: [] })
        }
    },
    computed: {
        filteredOverrideDays() {
            return (this.overrideDayData?.overrideDays || []).filter((x) => x.rowStatus !== rowStatus.DELETE);
        },
        hasOverrideDays() {
            return this.overrideDayData?.overrideDays?.length > 0;
        }
    },
    methods: {
        handleDeleteOverrideDay(overrideDay) {
            const index = this.overrideDayData.overrideDays.indexOf(overrideDay);

            if (index !== -1) {
                overrideDay.rowStatus = rowStatus.DELETE;
                return;
            }

            if (overrideDay.rowStatus === rowStatus.ADD && index !== -1) {
                this.overrideDayData.overrideDays.splice(index, 1);
            }
        },
        handleEditOverrideDay(overrideDay) {
            this.$emit('editOverrideDay', overrideDay);
        },
        handleAddOverrideDay() {
            const newOverrideDay = {
                overrideDayName: null,
                overrideDate: null,
                overrideDayWindows: [],
                rowStatus: rowStatus.ADD
            };

            this.overrideDayData.overrideDays.push(newOverrideDay);
        }
    }
};
</script>
<style lang="scss" scoped>
.custom-add-override-day-button,
.custom-add-override-day-button:hover {
    margin-left: 0;
    background-color: #5f6771 !important;
    margin-top: 10px;
}

.override-day-name-column {
    width: 300px;
    min-width: 300px;
    max-width: 300px;
}
.override-date-columns {
    width: 175px;
    min-width: 175px;
    max-width: 175px;
}
.override-day-table .md-table-row:nth-child(n + 3) > td {
    border-top: 0 !important;
}
.action-buttons-column button {
    margin-right: 5px;
}
</style>
